import React, { useEffect, useState } from 'react'
import { Modal, ModalBody } from "react-bootstrap";
import isNull from '../../../utils/NullChecking';
import { ServerRequestProtected } from '../../../utils/ServerDataRequest';
import NotificationHandler from '../../../utils/NotificationHandler';
import { enumUtil } from '../../../utils/Enum';
import FormValidator from '../../../utils/FormValidator';
import Loader from '../../shared/Loader/Loader';
import { FailedToStartTransportError } from '@microsoft/signalr/dist/esm/Errors';
import DatePicker from '../../General/DatePicker';
import SuperSearchMultipleClient from '../../shared/SuperSearch/MultipleSelection/SuperSearchMultipleClient';
import CustomTimePicker from '../../shared/CustomTimePicker/CustomTimePicker';
import { convertTo24Hour } from '../../../utils/Constants';

const MarkNewAttendance = React.memo((props) => {

  const { key, openPopup, onClose, onCloseSave, ID, AttendanceData, AttendanceType, searchDateParam, AttendanceProp, } = { ...props }

  const API_URL = enumUtil.controller.General;
  const API_URL_PATIENT = enumUtil.controller.PATIENT;
  const API_URL_Agency = enumUtil.controller.AgencyPatient;

  const DefaultStartTime = (AttendanceType === "Multiple" ? AttendanceData?.[0]?.DefaultStartTime : AttendanceData?.DefaultStartTime);
  const DefaulEndTime = (AttendanceType === "Multiple" ? AttendanceData?.[0]?.DefaulEndTime : AttendanceData?.DefaulEndTime);

  let Attendance_Modal = {

    Attendance: true,
    AttendanceDate: null,
    Absent: false,
    Present: true,
    CheckIn: DefaultStartTime,
    CheckOut: DefaulEndTime,
    AttendanceDays: "",
    Reason: "",

  }

  let Validation_Modal = {
    CheckIn: "",
    AttendanceDate: "",
    Days: "",
  }

  let valModal = {}

  const AttendanceDaysDD = [

    // { value: "All", display: "All" },
    { value: "Sunday", display: "Sunday" },
    { value: "Monday", display: "Monday" },
    { value: "Tuesday", display: "Tuesday" },
    { value: "Wednesday", display: "Wednesday" },
    { value: "Thursday", display: "Thursday" },
    { value: "Friday", display: "Friday" },
    { value: "Saturday", display: "Saturday" },

  ]

  const [MainMarkAttendanceModal, setMainMarkAttendanceModal] = useState(Attendance_Modal);
  const [SaveMarkAttendanceModal, setSaveMarkAttendanceModal] = useState({ Attendance: 'true', CheckIn: DefaultStartTime, CheckOut: DefaulEndTime, });
  const [AttendanceRecordID, setAttendanceRecordID] = useState(0);
  const [AttendanceRecordUpdated, setAttendanceRecordUpdated] = useState(0);
  const [AttendanceValidationModal, setAttendanceValidationModal] = useState(Validation_Modal);
  const [isLoading, setIsLoading] = useState(false);
  const [AttendanceRecordSaved, setAttendanceRecordSaved] = useState(false);
  const [AttendanceDaysValue, setAttendanceDaysValue] = useState([]);
  const [reloadSuperSearch, setReloadSuperSearch] = useState([]);
  const [searchParam, setSearchParam] = useState({ "timeString": "03:40 AM" });
  const [reloadCheckInKey, setReloadCheckInKey] = useState(false);


  const formValidation = () => {
    let validation = {
      // CheckIn: (MainMarkAttendanceModal?.Attendance ? FormValidator(MainMarkAttendanceModal?.CheckIn, enumUtil.enumValidationType.Required, 'Check In Time') : ""),
      // AttendanceDate: (MainMarkAttendanceModal?.Attendance ? FormValidator(MainMarkAttendanceModal?.AttendanceDate, enumUtil.enumValidationType.Required, 'Date') : ""),
      Days: ((AttendanceType === "Multiple" && MainMarkAttendanceModal?.Attendance) ? FormValidator(SaveMarkAttendanceModal?.AttendanceDays, enumUtil.enumValidationType.Required, 'Day') : ""),
    }
    setAttendanceValidationModal(validation);
    valModal = validation;
  }

  const timeComparison = (time, type) => {

    const time24hrs = convertTo24Hour(time);
    // Time should be in 24 hrs formate:
    const date1 = new Date(`1970-01-01T${time24hrs}`);
    console.log("time24hrs", time, time24hrs, date1);
    if (type === 'CheckIn') {
      if (!isNull(MainMarkAttendanceModal?.CheckOut)) {
        const checkOut24hrs = convertTo24Hour(MainMarkAttendanceModal?.CheckOut);
        // Time should be in 24 hrs formate:
        const date2 = new Date(`1970-01-01T${checkOut24hrs}`);

        if (date1 > date2) {
          return false;
        } else {
          return true;
        }

      } else {
        return true
      }

    } else if (type === 'CheckOut') {

      if (!isNull(MainMarkAttendanceModal?.CheckIn)) {
        const checkIn24hrs = convertTo24Hour(MainMarkAttendanceModal?.CheckIn);
        // Time should be in 24 hrs formate:
        const date2 = new Date(`1970-01-01T${checkIn24hrs}`);

        if (date1 < date2) {
          return false;
        } else {
          return true
        }

      } else {
        return true
      }

    }
  }

  const HandleOnChange = (e) => {

    const { value, name, checked, type } = e.target;

    let modal = { ...MainMarkAttendanceModal };
    let saveModal = { ...SaveMarkAttendanceModal };

    if (type === 'radio') {
      if (name === "Present") {
        if (checked) {
          modal['Attendance'] = true;
        }
      }
      else if (name === "Absent") {
        if (checked) {
          modal['Attendance'] = false;
        }
      }
    }
    else if (name === 'CheckIn' || name === 'CheckOut') {

      let comparison = timeComparison(value, name);
      if (comparison) {
        modal[name] = value
      } else {
        NotificationHandler('Please select a valid time', enumUtil?.enumtoaster?.warning)
      }
    }
    else {
      modal[name] = value;
    }


    for (let property in Attendance_Modal) {
      if (property === name) {
        if (type === 'radio') {
          if (name === "Present") {
            if (checked) {
              saveModal['Attendance'] = 'true';
            }

          }
          else if (name === "Absent") {
            if (checked) {
              saveModal['Attendance'] = 'false';
            }
          }
        }
        else {
          saveModal[name] = value;
        }
      }
    }

    setMainMarkAttendanceModal(modal);
    setSaveMarkAttendanceModal(saveModal);

  }

  const handleCalendarChange = (date, name) => {
    var FormatedDate = date
    let modal = { ...MainMarkAttendanceModal };
    let saveModal = { ...SaveMarkAttendanceModal };
    modal[name] = FormatedDate;
    setMainMarkAttendanceModal(modal);
    for (var property in Attendance_Modal) {
      if (name === property) {
        saveModal[name] = FormatedDate;
      }
    }
    setSaveMarkAttendanceModal(saveModal);
  };

  const handleSaveData = () => {
    formValidation();
    let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
    if (validation) {
      return
    }
    let saveModal = {}
    setIsLoading(true);
    if (AttendanceType === "Multiple") {

      let Data = Array.isArray(AttendanceData) ? AttendanceData?.map((attendance) => {

        let dataObj = {

          ...SaveMarkAttendanceModal,
          "CheckIn": !isNull(SaveMarkAttendanceModal['CheckIn']) ? SaveMarkAttendanceModal['CheckIn'] : attendance?.DefaultStartTime,
          "CheckOut": !isNull(SaveMarkAttendanceModal['CheckOut']) ? SaveMarkAttendanceModal['CheckOut'] : attendance?.DefaulEndTime,
          "PatientID": attendance?.PatientID,
          "PatientInsuranceID": attendance?.PatientInsuranceID,
          "PatientAuthorizationID": attendance?.PatientAuthorizationID,
          "DateFrom": searchDateParam?.DateFrom,
          "DateTo": searchDateParam?.DateTo,

        }

        return dataObj
      }) : [];

      saveModal = {
        TableName: enumUtil.enumAPITableName.PATIENTATTENDANCE,
        ID: AttendanceRecordID,
        Data: [...Data],
      }

      ServerRequestProtected(API_URL_Agency + '/SavePatientAttendance', 'post', saveModal)
        .then((response) => {

          setIsLoading(false);
          onCloseSave();
          NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success);

        }).catch((error) => {

          NotificationHandler(error.message, enumUtil.enumtoaster.error);
          setIsLoading(false);

        })
    } else {

      saveModal = {
        TableName: enumUtil.enumAPITableName.PATIENTATTENDANCE,
        ID: AttendanceRecordID,
        data: { ...SaveMarkAttendanceModal, AttendanceDate: AttendanceData?.DATE, PatientID: AttendanceData?.PatientID, PatientInsuranceID: AttendanceData?.PatientInsuranceID, PatientAuthorizationID: AttendanceData?.PatientAuthorizationID }
      }

      ServerRequestProtected(API_URL + '/SaveSingleRecord', 'post', saveModal)
        .then((response) => {

          setIsLoading(false);
          setAttendanceRecordSaved(true);
          setAttendanceRecordUpdated(!AttendanceRecordUpdated);
          onCloseSave();
          setAttendanceRecordID(response?.id)

          NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success);

        }).catch((error) => {

          NotificationHandler(error.message, enumUtil.enumtoaster.error);
          setIsLoading(false);

        })
    }

  }

  const handleTimeInADC = (e, Time1, Time2, type) => {

    let modal = { ...MainMarkAttendanceModal };
    let saveModal = { ...SaveMarkAttendanceModal };

    modal['CheckIn'] = Time1;
    saveModal['CheckIn'] = Time1;
    modal['CheckOut'] = Time2;
    saveModal['CheckOut'] = Time2;

    setMainMarkAttendanceModal(modal);
    setSaveMarkAttendanceModal(saveModal);
    setReloadCheckInKey(!reloadCheckInKey);
  }

  const [reloadCheckIn, setreloadCheckIn] = useState(false);
  const [reloadCheckOut, setReloadCheckOut] = useState(false);

  useEffect(() => {

    if (!isNull(ID)) {
      setAttendanceRecordID(ID);
    }

  }, [ID]);

  useEffect(() => {
    if (!isNull(AttendanceRecordID)) {

      setIsLoading(true);
      let SaveModal = {
        "ID": AttendanceRecordID,
        "TableName": enumUtil.enumAPITableName.PATIENTATTENDANCE,
      }

      ServerRequestProtected(API_URL + '/FindByID', 'post', SaveModal)
        .then((response) => {

          setIsLoading(false);
          setMainMarkAttendanceModal(response);
          setSaveMarkAttendanceModal({ ...SaveMarkAttendanceModal, Attendance: response?.Attendance + "" })

        }).catch((error) => {
          setIsLoading(false);
          NotificationHandler(error.message, enumUtil.enumtoaster.error);
        })

    } else if (isNull(AttendanceRecordID) && AttendanceProp === false) {
      setMainMarkAttendanceModal({ ...MainMarkAttendanceModal, Attendance: AttendanceProp });
      setSaveMarkAttendanceModal({ ...SaveMarkAttendanceModal, Attendance: AttendanceProp + '' });
    }
  }, [AttendanceRecordID, AttendanceRecordUpdated])

  // useEffect(() => {
  //   console.log("SEARCH_PARAM_TIMESTRING", SaveMarkAttendanceModal)
  // }, [])

  return (
    <Modal show={openPopup} onHide={openPopup} backdrop="static" keyboard={false} centered dialogClassName="delete-modal hk-modal-v1 Mark_Attandance">
      <div className="d-flex justify-content-between align-items-center br-bottom-1 ar-border-color pb-2 pt-15 px-10">
        <p className="heading fs-14 dark-clr">Attendance</p>
        <i className='icon-x-cros fs-20 dark-clr' onClick={() => { AttendanceRecordSaved ? onCloseSave() : onClose() }} ></i>
      </div>
      <Modal.Body>

        {isLoading ? <Loader /> : <></>}
        {console.log("AttendanceType", AttendanceType, AttendanceData)}
        <div className="d-flex justify-content-between align-items-center mb-2">
          <div className="d-flex gap-15">
            {(isNull(AttendanceRecordID) && AttendanceProp === false)
              ? <></> : <div className="ar_radio-btn d-flex align-items-center gap-1">
                <input
                  type="radio"
                  name='Present'
                  id='Present'
                  checked={MainMarkAttendanceModal?.Attendance}
                  onChange={(e) => HandleOnChange(e)}
                />
                <p for="Active" className="text fs-12 ar-orange-text" >Present</p>
              </div>}
            <div className="ar_radio-btn d-flex align-items-center gap-1">
              <input
                type="radio"
                name='Absent'
                id='Absent'
                checked={!MainMarkAttendanceModal?.Attendance}
                onChange={(e) => HandleOnChange(e)}
              />
              <p for="InActive" className="text fs-12 ar-orange-text" >Absent</p>
            </div>
          </div>
          <p className='fst-italic text fs-13 light-clrs d-flex align-items-end '>{searchDateParam?.DateFrom} - {searchDateParam?.DateTo}</p>
        </div>
        {/* <div className={`input ar-multiple-br w-100`}>
          <label> Time<span style={{ color: 'red' }}>*</span></label>
          <TimeControlDropdown className="mb-1" name="timeString" SearchParam={searchParam} setSearchParam={setSearchParam} />
        </div> */}
        {/* <div className={`d-flex gap-12 ${MainMarkAttendanceModal?.Attendance ? '' : 'disable_fields'} mb-2`}>
          <div className={`input w-50 pe-2 ${AttendanceValidationModal?.AttendanceDate ? 'error' : ''}`}>
            <label className="hs-patient-label">Date<span className='req'>*</span></label>

            <DatePicker
              label={<>Date<span className='req'>*</span></>}
              value={MainMarkAttendanceModal.AttendanceDate}
              className= 'mb-0'
              handleCalendarChangefunc={(date) =>
                handleCalendarChange(date, "AttendanceDate")
              }
              minDate={new Date()}
              inputError={AttendanceValidationModal?.AttendanceDate ? true : false}
            />

            {AttendanceValidationModal?.AttendanceDate}
          </div>
        </div> */}
        {AttendanceType === "Multiple" ?
          <div className={`d-flex gap-12 mb-2`}>

            <div className={`input ar-multiple-br w-100`}>
              <label> Days<span style={{ color: 'red' }}>*</span></label>
              <div className={AttendanceValidationModal.Days ? "error input" : "input"}>

                <SuperSearchMultipleClient
                  key={reloadSuperSearch}
                  view={'MultiOptions'}
                  type="client"
                  id="AttendanceDays"
                  name="AttendanceDays"
                  selectedOptionsDisplay='AttendanceDays'
                  initialSelectedValues={AttendanceDaysValue}
                  searchParam={SaveMarkAttendanceModal}
                  setSearchParam={setSaveMarkAttendanceModal}
                  options={AttendanceDaysDD}
                  sup_btn="sup_btn-Inp"
                  sup_inp="superSearchVisitInp"
                  inputError={AttendanceValidationModal.Days ? true : false}
                />

                {AttendanceValidationModal?.Days}
              </div>
            </div>

          </div> : <></>}

        {MainMarkAttendanceModal?.Attendance ? <div className={`d-flex gap-12 ${MainMarkAttendanceModal?.Attendance ? '' : 'disable_fields'}`}>
          <div className={`input w-100 ${AttendanceValidationModal?.CheckIn ? 'error' : ''}`} onClick={(e) => { setReloadCheckOut(!reloadCheckOut); console.log("reloadCheckOut", reloadCheckOut) }}>
            <label className='text fs-12 ar-light-color '>Check In</label>

            <CustomTimePicker className="mb-1" name="CheckIn" initialValue={MainMarkAttendanceModal?.CheckIn} handleOnChange={HandleOnChange} />
            {/* <input type="time" className={`form-control fc-xs rounded-1`} readOnly={!MainMarkAttendanceModal?.Attendance} id="CheckIn" name="CheckIn" value={MainMarkAttendanceModal?.CheckIn} onChange={(e) => HandleOnChange(e)} /> */}
            {AttendanceValidationModal?.CheckIn}
          </div>

          <div className="input w-100" onClick={(e) => { setReloadCheckInKey(!reloadCheckOut) }}>
            <label className='text fs-12 ar-light-color'>Check Out</label>
            <CustomTimePicker className="mb-1" name="CheckOut" initialValue={MainMarkAttendanceModal?.CheckOut} handleOnChange={HandleOnChange} />
            {/* <CustomTimePicker /> */}
            {/* <input type="time" className={`form-control fc-xs rounded-1`} readOnly={!MainMarkAttendanceModal?.Attendance} id="CheckOut" name="CheckOut" value={MainMarkAttendanceModal?.CheckOut} onChange={(e) => HandleOnChange(e)} /> */}
          </div>
        </div> : <></>}

        {!MainMarkAttendanceModal?.Attendance ?
          <div className='form-group input'>
            <label htmlFor="Comments">Reason</label>
            <textarea type="text"
              rows={2}
              className='form-control'
              id="Reason"
              name="Reason"
              value={MainMarkAttendanceModal.Reason}
              onChange={(e) => HandleOnChange(e)}
            />
          </div> : <></>}

        {MainMarkAttendanceModal?.Attendance ? <div className='za-create_master_weekpopup'>
          <div className='modal_footer p-0 m-0'>
            <div className='d-flex align-items-center gap-1 paragraph p-0 m-0 px-1-5'>
              <i className='icon-Vector13 fs-14'></i>
              <p className='text fs-11 fst-italic py-1'><span className='za-blue-clr text-decoration-underline cursor-pointer' onClick={(e) => handleTimeInADC(e, DefaultStartTime, DefaulEndTime, '')}>Use default time:</span> {DefaultStartTime} as check in and {DefaulEndTime} as check out.</p>
            </div>
          </div>
        </div> : <></>}
      </Modal.Body>
      {/* <div className='za-create_master_weekpopup'>
        <div className="modal_footer ar-border-color br-top-1 br-clr px-10">

          <div className='za-button text-end'>
            <button className='btn btn-gray text fs-12 px-10 text-black' onClick={() => AttendanceRecordSaved ? onCloseSave() : onClose()}> Cancel</button>
            <button className='btn btn-orange text fs-12 px-10 text-white ms-2' onClick={() => handleSaveData()}> Mark Attendance</button>
          </div>
        </div>
      </div> */}
      <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
        <button className='btn btn-validate px-10 h-100'onClick={() => handleSaveData()}>Mark Attendance</button>
      </div>
    </Modal>
  )
})

export default MarkNewAttendance
